import {FieldValues, FieldPath, useFormContext} from 'react-hook-form'
import {useEffect} from 'react'
import {isString} from 'lodash'
import {useAddedFields} from './useAddedFields'

export const useAutosaveAddedFields = <
  TFieldValues extends FieldValues,
  TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  addedFieldsName: TFieldName
) => {
  const {watch} = useFormContext<TFieldValues>()
  const [, saveAddedFields] = useAddedFields()

  useEffect(() => {
    const subscription = watch((data, {name}) => {
      if (name === addedFieldsName) {
        saveAddedFields(data[addedFieldsName].filter(isString))
      }
    })
    return () => subscription.unsubscribe()
  }, [addedFieldsName, watch, saveAddedFields])
}
